// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"ed21695cf4d4a5a3c88f","303":"3f49b9ad0a6c315e362d","495":"0fdba535c5455883ba6f"}[chunkId] + ".js";
};